import { RouterProvider } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { HelmetProvider } from 'react-helmet-async'
import { I18nextProvider } from 'react-i18next'
import { ErrorBoundary } from 'react-error-boundary'
import { router } from './router'
import { queryClient } from './lib/queryClient'
import i18n from './features/i18n'
import { reportClientError } from './lib/clientErrorReporter'

// 에러 바운더리 폴백 — 예상치 못한 렌더링 오류 시 표시
function ErrorFallback({ error, resetErrorBoundary }: { error: Error; resetErrorBoundary: () => void }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-deep p-8">
      <div className="text-center max-w-md">
        <div className="text-6xl mb-6">⚠️</div>
        <h1 className="text-2xl font-bold text-ink mb-3">예상치 못한 오류가 발생했습니다</h1>
        <p className="text-ink-muted mb-2 text-sm">{error.message}</p>
        <p className="text-ink-faint text-xs mb-8">문제가 지속되면 contact@saife.dasancms.co.kr 로 문의해주세요.</p>
        <button
          onClick={resetErrorBoundary}
          className="px-6 py-2.5 bg-brand-primary hover:bg-brand-primary-dark text-white rounded-xl font-medium transition-colors"
        >
          다시 시도
        </button>
      </div>
    </div>
  )
}

export default function App() {
  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={(error, info) => reportClientError({
        kind: 'react',
        message: error.message,
        stack: error.stack ?? null,
        context: { componentStack: info?.componentStack?.slice(0, 4000) },
      })}
    >
      <HelmetProvider>
        <I18nextProvider i18n={i18n}>
          <QueryClientProvider client={queryClient}>
            {/* RouterProvider 가 내부적으로 BrowserRouter 역할을 하므로
                AuthProvider / Toast는 router 루트 레이아웃(AppRoot)에서 제공 */}
            <RouterProvider router={router} />
          </QueryClientProvider>
        </I18nextProvider>
      </HelmetProvider>
    </ErrorBoundary>
  )
}
